<template>
  <div class="wrapper-jishen">
    <card class="card" v-if="enableHitScore">
      <div class="card-title">系统评分</div>

      <el-table :data="hitScoreRows">
        <el-table-column label="序号" prop="index" />
        <el-table-column label="规则名称" prop="ruleName" />
        <el-table-column label="规则权重" prop="hitScore">
          <template slot-scope="{ row }">
            <span class="danger-cell">{{ row.hitScore }}</span>
          </template>
        </el-table-column>
      </el-table>
    </card>

    <card class="card">
      <div class="card-title">重点关注</div>

      <div class="card-content">
        <el-row>
          <el-col
              v-for="(item, index) in keyAttentionRows"
              :key="index"
              :span="item.width ? item.width : 6"
          >
            <span class="label">{{ item.label }}：</span>
            <span class="value">{{ item.value }}</span>
          </el-col>
        </el-row>
      </div>
    </card>

    <card class="card">
      <div class="card-title">法律诉讼</div>

      <div class="card-content">
        <el-row>
          <el-col
              v-for="(item, index) in involvementStatRows"
              :key="index"
              :span="item.width ? item.width : 6"
          >
            <span class="label">{{ item.label }}：</span>
            <span class="value">{{ item.value }}</span>
          </el-col>
        </el-row>
      </div>

      <el-table :data="involvementRows" style="margin-top: 10px;">
        <el-table-column label="序号" prop="index" width="100" />
        <el-table-column label="日期" prop="caseTime" width="150" />
        <el-table-column label="类型" prop="dataType" width="150" />
        <el-table-column label="标题" prop="title" />
        <el-table-column label="内容摘要" prop="content" />
      </el-table>
    </card>

    <card class="card">
      <div class="card-title">贷款行为</div>

      <div>
        <div class="sub-section-title">
          <i class="el-icon-data-line"></i>
          <span>优分汇总</span>
        </div>
        <div class="card-content">
          <el-row>
            <el-col
                v-for="(item, index) in yfSummaryRows"
                :key="index"
                :span="item.width ? item.width : 6"
            >
              <span class="label">{{ item.label }}：</span>
              <span class="value">{{ item.value }}</span>
            </el-col>
          </el-row>
        </div>
      </div>

      <div style="margin-top: 20px;">
        <div class="sub-section-title">
          <i class="el-icon-data-line"></i>
          <span>新颜汇总</span>
        </div>
        <div class="card-content">
          <el-row>
            <el-col
                v-for="(item, index) in xyStatRows"
                :key="index"
                :span="item.width ? item.width : 8"
            >
              <span class="label">{{ item.label }}：</span>
              <span class="value">{{ item.value }}</span>
            </el-col>
          </el-row>
        </div>

        <el-table :data="xyLoanRows" style="margin-top: 10px;">
          <el-table-column label="" prop="title" />
          <el-table-column label="近1个月" prop="m1" />
          <el-table-column label="近3个月" prop="m3" />
          <el-table-column label="近6个月" prop="m6" />
          <el-table-column label="近12个月" prop="m12" />
        </el-table>
      </div>
    </card>

    <!--    <card class="card">-->
    <!--      <AdminTitle title="百融贷前汇总" size="20px" />-->

    <!--      <el-table :data="brApplyRecord" :style="{ marginBottom: '20px' }">-->
    <!--        <el-table-column prop="title">-->
    <!--          <p slot="header" class="table-svg-header">-->
    <!--            <svg-->
    <!--                width="20"-->
    <!--                height="20"-->
    <!--                viewBox="0 0 20 20"-->
    <!--                fill="none"-->
    <!--                xmlns="http://www.w3.org/2000/svg"-->
    <!--            >-->
    <!--              <path-->
    <!--                  fill-rule="evenodd"-->
    <!--                  clip-rule="evenodd"-->
    <!--                  d="M2.91675 3.33317C2.91675 2.4127 3.66294 1.6665 4.58341 1.6665H13.6786L17.0834 5.07133V16.6665C17.0834 17.587 16.3372 18.3332 15.4167 18.3332H4.58341C3.66294 18.3332 2.91675 17.587 2.91675 16.6665V3.33317ZM12.9882 3.33317L4.58341 3.33317V16.6665H15.4167V5.76168L12.9882 3.33317Z"-->
    <!--                  fill="#222222"-->
    <!--              />-->
    <!--              <path-->
    <!--                  d="M6.66675 6.6665H8.18924L10.0001 9.89129L11.8109 6.6665H13.3334L11.0843 10.3535H12.6183V11.0047H10.6806L10.6691 11.0152V11.9186H12.6183V12.5699H10.6691V14.1665H9.33111V12.5699H7.39339V11.9186H9.33111V11.0152L9.31957 11.0047H7.39339V10.3535H8.91588L6.66675 6.6665Z"-->
    <!--                  fill="black"-->
    <!--              />-->
    <!--            </svg>-->
    <!--            申请记录-->
    <!--          </p>-->
    <!--        </el-table-column>-->
    <!--        <el-table-column label="近7天" prop="d7"></el-table-column>-->
    <!--        <el-table-column label="近15天" prop="d15"></el-table-column>-->
    <!--        <el-table-column label="近1个月" prop="m1"></el-table-column>-->
    <!--        <el-table-column label="近3个月" prop="m3"></el-table-column>-->
    <!--        <el-table-column label="近6个月" prop="m6"></el-table-column>-->
    <!--      </el-table>-->
    <!--    </card>-->

    <!--    <card class="card">-->
    <!--      <AdminTitle title="百融贷前汇总" size="20px" />-->
    <!--    </card>-->
  </div>
</template>

<script>
import { getOrderRiskReviewDetailAPI } from "./api";

export default {
  name: "JiShen",

  data() {
    return {
      detail: {},
      enableHitScore: false,
      baiRong: {},
      youFen: {},
      xySpray: {},
      xyProbe: {},
      alipayRisk: {},
    };
  },

  computed: {
    member() {
      return this.detail.member || {};
    },

    finalLevel() {
      return this.detail.orderScoreProfile ? this.detail.orderScoreProfile.finalHitGrade : "";
    },

    scoreProfileData() {
      return this.detail.scoreProfileData || {};
    },

    hitScoreRows() {
      return (this.detail.hitScoreBillList ?? []).map((record, index) => {
        return {
          index: index + 1,
          ruleName: this.renderText(record.ruleName),
          hitScore: this.renderText(record.hitScore),
          hitSuggestDesc: this.renderText(record.hitSuggestDesc),
        };
      });
    },

    keyAttentionRows() {
      return [
        {
          label: "租安盾共租风险",
          value: this.renderText(this.alipayRisk?.zadMultiRisk || '-'),
        },
        {
          label: "当前逾期机构数",
          value: this.renderText(this.xyProbe?.currOverdueOrgNum || '-'),
        },
        {
          label: "黑名单等级",
          value: this.renderText(this.youFen?.blacklistLevel || '-'),
        },
        {
          label: "运营商在网时长",
          value: this.renderText(this.youFen?.netTime || '-'),
        },
        {
          label: "反欺诈评分",
          value: this.renderText(this.baiRong?.afRuleScore || '-'),
        },
        {
          label: "债偿压力指数",
          value: this.renderText(this.baiRong?.debtRepayStress || '-'),
        },
        {
          label: "综合风险",
          value: this.renderText(this.youFen?.riskCheck || '-'),
        },
        {
          label: "疑似养卡",
          value: this.renderText(this.youFen?.suspendCard || '-'),
        },
      ];
    },

    involvementStatRows() {
      return [
        {
          label: "个人涉诉总数",
          value: this.renderText(this.youFen?.personInvolvement?.count || '-'),
        },
        {
          label: "裁判文书",
          value: this.renderText(this.youFen?.personInvolvement?.judgeDocumentCount || '-'),
        },
        {
          label: "开庭公告",
          value: this.renderText(this.youFen?.personInvolvement?.openCourtNoticeCount || '-'),
        },
        {
          label: "执行公告",
          value: this.renderText(this.youFen?.personInvolvement?.executeNoticeCount || '-'),
        },
        {
          label: "失信公告",
          value: this.renderText(this.youFen?.personInvolvement?.dishonestyNoticeCount || '-'),
        },
        {
          label: "案件流程",
          value: this.renderText(this.youFen?.personInvolvement?.caseProduceCount || '-'),
        },
        {
          label: "曝光台",
          value: this.renderText(this.youFen?.personInvolvement?.exposureCount || '-'),
        },
      ];
    },

    involvementRows() {
      if (!this.youFen.personInvolvement || !this.youFen.personInvolvement.list) {
        return [];
      }
      return this.youFen.personInvolvement.list.map((row, index) => {
        return {
          index: index + 1,
          caseTime: this.renderText(row.caseTime),
          dataType: this.renderText(row.dataType),
          title: this.renderText(row.title),
          content: this.renderText(row.content),
        };
      });
    },

    yfSummaryRows() {
      return [
        {
          label: "申请机构总数",
          value: this.renderText(this.youFen?.applyOrgNum || '-'),
        },
        {
          label: "近12个月逾期次数",
          value: this.renderText(this.youFen?.m12OverdueNum || '-'),
        },
        {
          label: "近24个月逾期次数",
          value: this.renderText(this.youFen?.m24OverdueNum || '-'),
        },
        {
          label: "最近逾期距今天数",
          value: this.renderText(this.youFen?.overdueRecentlyDay || '-'),
        },
        {
          label: "最早逾期距今天数",
          value: this.renderText(this.youFen?.overdueHistoryDay || '-'),
        },
        {
          label: "逾期最大金额距今最近天数",
          value: this.renderText(this.youFen?.overdueMaxMoneyRecentlyDay || '-'),
        },
        {
          label: "逾期最大金额距今最早天数",
          value: this.renderText(this.youFen?.overdueMaxMoneyHistoryDay || '-'),
        },
      ];
    },

    xyStatRows() {
      return [
        {
          label: "申请命中机构数",
          value: this.renderText(this.xySpray?.applyHitOrgNum || '-'),
        },
        {
          label: "申请命中消金类机构数",
          value: this.renderText(this.xySpray?.applyHitConsumeLoanOrgNum || '-'),
        },
        {
          label: "申请命中网络贷款类机构数",
          value: this.renderText(this.xySpray?.applyHitNetLoanOrgNum || '-'),
        },
        {
          label: "机构总查询次数",
          value: this.renderText(this.xySpray?.totalOrgQueryNum || '-'),
        },
        {
          label: "最近一次查询时间",
          value: this.renderText(this.xySpray?.lastOrgQueryTime || '-'),
        },
        {
          label: "正常还款订单比例",
          value: this.renderText(this.xySpray?.normalRepayOrderRate || '-'),
        },
      ];
    },

    xyLoanRows() {
      return [
        {
          title: '申请历史',
          m1: this.renderText(this.xySpray?.m1OrgQueryNum || '-'),
          m3: this.renderText(this.xySpray?.m3OrgQueryNum || '-'),
          m6: this.renderText(this.xySpray?.m6OrgQueryNum || '-'),
          m12: '-',
        },
        {
          title: '贷款笔数',
          m1: this.renderText(this.xySpray?.m1LoanNum || '-'),
          m3: this.renderText(this.xySpray?.m3LoanNum || '-'),
          m6: this.renderText(this.xySpray?.m6LoanNum || '-'),
          m12: this.renderText(this.xySpray?.m12LoanNum || '-'),
        },
        {
          title: '贷款金额',
          m1: this.renderText(this.xySpray?.m1LoanAmount || '-'),
          m3: this.renderText(this.xySpray?.m3LoanAmount || '-'),
          m6: this.renderText(this.xySpray?.m6LoanAmount || '-'),
          m12: this.renderText(this.xySpray?.m12LoanAmount || '-'),
        },
        {
          title: '贷款机构数',
          m1: this.renderText(this.xySpray?.m1LoanOrgNum || '-'),
          m3: this.renderText(this.xySpray?.m3LoanOrgNum || '-'),
          m6: this.renderText(this.xySpray?.m6LoanOrgNum || '-'),
          m12: this.renderText(this.xySpray?.m12LoanOrgNum || '-'),
        },
        {
          title: 'M0+逾期笔数',
          m1: this.renderText(this.xySpray?.m1M0OverdueLoanNum || '-'),
          m3: this.renderText(this.xySpray?.m3M0OverdueLoanNum || '-'),
          m6: this.renderText(this.xySpray?.m6M0OverdueLoanNum || '-'),
          m12: this.renderText(this.xySpray?.m12M0OverdueLoanNum || '-'),
        },
        {
          title: 'M1+逾期笔数',
          m1: this.renderText(this.xySpray?.m1M1OverdueLoanNum || '-'),
          m3: this.renderText(this.xySpray?.m3M1OverdueLoanNum || '-'),
          m6: this.renderText(this.xySpray?.m6M1OverdueLoanNum || '-'),
          m12: this.renderText(this.xySpray?.m12M1OverdueLoanNum || '-'),
        },
        {
          title: '逾期金额',
          m1: this.renderText(this.xySpray?.m1TotalOverdueAmount || '-'),
          m3: this.renderText(this.xySpray?.m3TotalOverdueAmount || '-'),
          m6: this.renderText(this.xySpray?.m6TotalOverdueAmount || '-'),
          m12: this.renderText(this.xySpray?.m12TotalOverdueAmount || '-'),
        },
        {
          title: '扣款失败笔数',
          m1: this.renderText(this.xySpray?.m1FailDeductNum || '-'),
          m3: this.renderText(this.xySpray?.m3FailDeductNum || '-'),
          m6: this.renderText(this.xySpray?.m6FailDeductNum || '-'),
          m12: this.renderText(this.xySpray?.m12FailDeductNum || '-'),
        },
      ];
    },

    brApplyRecord() {
      return [
        {
          title: "线上消费分期的次数",
          d7: this.renderText(this.baiRong.d7CoonAllNum),
          d15: "-",
          m1: "-",
          m3: "-",
          m6: "-",
        },
        {
          title: "线上消费分期的机构数",
          d7: this.renderText(this.baiRong.d7CoonOrgNum),
          d15: "-",
          m1: "-",
          m3: "-",
          m6: "-",
        },
        {
          title: "持牌小贷机构申请次数",
          d7: this.renderText(this.baiRong.d7NbankSloanAllNum),
          d15: "-",
          m1: "-",
          m3: "-",
          m6: "-",
        },
        {
          title: "持牌小贷机构申请机构数",
          d7: this.renderText(this.baiRong.d7NbankSloanOrgNum),
          d15: "-",
          m1: "-",
          m3: "-",
          m6: "-",
        },
        {
          title: "持牌融资租赁机构申请次数",
          d7: "-",
          d15: this.renderText(this.baiRong.d15NbankFinleaAllNum),
          m1: "-",
          m3: "-",
          m6: "-",
        },
        {
          title: "非银机构周末申请机构数",
          d7: "-",
          d15: this.renderText(this.baiRong.d15NbankWeekOrgNum),
          m1: "-",
          m3: "-",
          m6: "-",
        },
        {
          title: "非银机构申请次数",
          d7: "-",
          d15: "-",
          m1: this.renderText(this.baiRong.m1IdNbankAllNum),
          m3: this.renderText(this.baiRong.m3IdNbankAllNum),
          m6: this.renderText(this.baiRong.m6NbankAllNum),
        },
        {
          title: "申请汽车金融的机构数",
          d7: "-",
          d15: "-",
          m1: this.renderText(this.baiRong.m1AfOrgNum),
        },
        {
          title: "非银机构-其他申请次数",
          d7: "-",
          d15: "-",
          m1: "-",
          m3: "-",
          m6: this.renderText(this.baiRong.m6NbankOthAllNum),
        },
        {
          title: "非银机构-消费类分期机构申请次数",
          d7: "-",
          d15: "-",
          m1: "-",
          m3: "-",
          m6: this.renderText(this.baiRong.m6NbankCfAllNum),
        },
        {
          title: "按身份证号查询在非银机构申请次数",
          d7: "-",
          d15: "-",
          m1: "-",
          m3: "-",
          m6: this.renderText(this.baiRong.m6IdNbankAllNum),
        },
      ];
    },
  },

  mounted() {
    this.enableHitScore = this.$route.query.orderType == 2 || this.$route.query.orderType == 4;
    this.getRiskReview();
  },

  methods: {
    renderText(value) {
      return value ?? "-";
    },

    async getRiskReview() {
      const res = await getOrderRiskReviewDetailAPI(this.$route.params.id);
      this.detail = res;
      this.baiRong = res.baiRong;
      this.youFen = res.youFen;
      this.xySpray = res.xySpray
      this.xyProbe = res.xyProbe;
      this.alipayRisk = res.alipayRisk;
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  border-radius: 12px;
  margin-bottom: 20px;
  border: none;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  
  ::v-deep .el-card__body {
    padding: 24px;
  }
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  padding-bottom: 16px;
  margin-bottom: 16px;
  border-bottom: 1px solid #e4e7ed;
  color: #303133;
  position: relative;
  
  &::before {
    content: '';
    position: absolute;
    left: -24px;
    top: 0;
    bottom: 0;
    width: 4px;
    background: linear-gradient(180deg, #409EFF 0%, #66b1ff 100%);
  }
}

.danger-cell {
  color: #f56c6c;
  font-weight: 600;
}

.without-layout .wrapper-jishen ::v-deep {
  overflow-y: scroll;
  margin-top: 0;

  .table-svg-header {
    display: flex;
    gap: 5px;
    align-items: center;
  }

  .el-table {
    border-radius: 8px;
    overflow: hidden;
    
    .el-table__header {
      .el-table__cell {
        font-weight: 600;
        background: linear-gradient(135deg, #f8f9fa 0%, #f0f2f5 100%);
        color: #303133;
        border-bottom: 2px solid #e4e7ed;
      }
    }
    
    .el-table__body {
      tr {
        transition: all 0.3s ease;
        
        &:hover {
          background-color: #f5f7fa;
        }
      }
    }
  }

  .performance-records-table tbody tr:not(:last-child) td {
    &:first-child {
      background: #fef0f0;
    }
    color: #f56c6c;
  }
}

.wrapper-jishen ::v-deep {
  .el-table {
    border-radius: 8px;
    overflow: hidden;
    
    .el-table__header {
      .el-table__cell {
        font-weight: 600;
        background: linear-gradient(135deg, #f8f9fa 0%, #f0f2f5 100%);
        color: #303133;
        border-bottom: 2px solid #e4e7ed;
      }
    }
    
    .el-table__body {
      tr {
        transition: all 0.3s ease;
        
        &:hover {
          background-color: #f5f7fa;
        }
      }
    }
  }
}

.sub-section-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  
  i {
    font-size: 18px;
    color: #409EFF;
  }
}

.card-content {
  line-height: 36px;
  padding: 16px 0;

  .label {
    display: inline-block;
    min-width: 120px;
    text-align: right;
    color: #606266;
    font-weight: 500;
  }

  .value {
    font-weight: 600;
    color: #303133;
  }
}

.online-summary {
  display: flex;
  flex-wrap: wrap;
  row-gap: 16px;
  column-gap: 16px;
  margin-bottom: 12px;

  .online-summary-item {
    width: calc(50% - 8px);
    background-color: #f7f8fa;
    border-radius: 8px;
    padding: 16px;

    .online-summary-item-header {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 12px;
      color: #222222;
      display: flex;
      align-items: center;
      gap: 5px;
    }

    .online-summary-item-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 22px;

      &:not(:last-child) {
        margin-bottom: 12px;
      }

      & > span:first-child {
        color: #666666;
      }

      & > span:last-child {
        color: #222222;
      }

      &.danger-row span {
        color: #d05252 !important;
      }
    }
  }
}
</style>
